export enum BeamerNameConstants {
	BEAMER_ANNOUNCEMENT_BAR = "beamerAnnouncementBar"
}
